"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AppSpinner = function AppSpinner(props) {
  return _react["default"].createElement(_core.CircularProgress, {
    size: 100,
    style: {
      marginBottom: 20
    },
    className: 'circle-progress ' + props.className
  });
};

var _default = AppSpinner;
exports["default"] = _default;